import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Divider } from 'antd';
import React, { ReactElement } from 'react';
import CustomTooltip from './CustomTooltip';

export interface FormDividerProps {
  text: string;
  fontSize?: number;
  id?: string;
  required?: boolean;
  width?: number;
  isDescriptionNeeded?: boolean;
  tooltipText?: ReactElement;
}

const FORM_DIVIDER_TITLE_DEFAULT_WIDTH_PERCENT = 100;
const FORM_DIVIDER_TITLE_DEFAULT_FONTSIZE = 14;
const FormDividerTitle = ({
  text,
  fontSize = FORM_DIVIDER_TITLE_DEFAULT_FONTSIZE,
  id = '',
  required = false,
  width = FORM_DIVIDER_TITLE_DEFAULT_WIDTH_PERCENT,
  isDescriptionNeeded = false,
  tooltipText,
}: FormDividerProps) => {
  return (
    <div className="form-title-wrapper" style={{ width: `${width}%` }}>
      <div id={id} className={'form-divider-anchor'} />
      <Divider className={`form-divider-title`} />
      <div
        className="form-title-text ant-form-item-label-divider"
        style={{ fontSize: fontSize + 'px' }}
      >
        <label
          className={`ant-form-item-no-colon ${
            required ? 'ant-form-item-required' : ''
          }`}
          style={{ fontSize: fontSize + 'px' }}
        >
          {text}
        </label>
        {isDescriptionNeeded ? (
          <CustomTooltip
            content={tooltipText}
            style={{
              width: '330px',
              borderRadius: '8px',
              transform: 'translateY(-128%)',
            }}
          >
            <ExclamationCircleOutlined />
          </CustomTooltip>
        ) : null}
      </div>
    </div>
  );
};

export default FormDividerTitle;
